import React from 'react';
import Radium from 'radium';
import TextField from 'material-ui/TextField';
import Theme from '../../styles/theme';
import CloseIcon from '../images/CloseIcon';

class TextInput extends React.Component {
	static propTypes = {
		darkBackground: React.PropTypes.bool,
		defaultValue: React.PropTypes.string,
		errorHintText: React.PropTypes.string,
		errorStyle: React.PropTypes.object,
		hasFocus: React.PropTypes.bool,
		hintStyle: React.PropTypes.object,
		hintText: React.PropTypes.string,
		inputIconStyle: React.PropTypes.object,
		inputStyle: React.PropTypes.object,
		maxlength: React.PropTypes.number,
		multiline: React.PropTypes.bool,
		name: React.PropTypes.string,
		onBlur: React.PropTypes.func,
		onChange: React.PropTypes.func,
		onFocus: React.PropTypes.func,
		onInputBlur: React.PropTypes.func,
		onKeyUp: React.PropTypes.func,
		onInputChange: React.PropTypes.func,
		placeholder: React.PropTypes.string,
		rows: React.PropTypes.number,
		rowsMax: React.PropTypes.number,
		style: React.PropTypes.object,
		type: React.PropTypes.string,
		underlineFocusStyle: React.PropTypes.object,
		underlineStyle: React.PropTypes.object,
		valid: React.PropTypes.bool,
		wrapperStyle: React.PropTypes.object,
	};

	static defaultProps = {
		valid: true,
		onBlur: () => {},
		multiline: false,
		rows: 1,
		rowsMax: 3,
	};

	constructor(props) {
		super(props);
		if (props.defaultValue && props.defaultValue.length > 0) {
			this.state = {
				hasValue: props.defaultValue,
				value: props.defaultValue,
			};
		}
	}

	state = {
		hasValue: false,
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps.defaultValue &&
			nextProps.defaultValue.length > 0 &&
			nextProps.defaultValue !== this.props.defaultValue) {
			this.setState({ value: nextProps.defaultValue });
		}
	}

	handleChange = (e) => {
		this.setState({ value: e.target.value });
		if (this.props.onInputChange) {
			this.props.onInputChange(e);
		}
		if (this.props.onChange) {
			this.props.onChange(e);
		}
		this.setState({ hasValue: e.target.value.length > 0 });
	};


	clearInput = () => {
		this.setState(
			{
				value: '',
			}
		);
		this.domElement.focus();
	};

	handleBlur = (onBlur) => {
		return (e) => {
			if (onBlur) {
				onBlur(e);
			}

			if (this.props.onInputBlur) {
				this.props.onInputBlur(e);
			}

			this.setState({ hasValue: e.target.value.length > 0 });
		};
	};

	getColorByState = () => {
		const isValid = this.props.valid;
		const hasValue = this.state.hasValue;

		if (!hasValue && isValid) {
			return Theme.palette.primary1Color;
		}

		if (isValid) {
			return Theme.palette.primary1Color;
		}

		return Theme.palette.errorColor;
	};

	getStyle() {
		return {
			textinput: {
				fontFamily: 'PxGroteskRegular',
				marginBottom: '14px',
				...this.props.style,
			},
			textareaStyle: {
				padding: '0px',
				...this.props.inputStyle,
			},
			hintStyle: {
				paddingLeft: '10px',
				...this.props.hintStyle,
			},
			inputStyle: {
				paddingLeft: '8px',
				paddingRight: this.props.multiline ? '0px' : '32px',
				...this.props.inputStyle,
			},
			errorStyle: {
				paddingLeft: '8px',
				paddingRight: '8px',
				color: this.getColorByState(),
				...this.props.errorStyle,
			},
			underline: {
				borderColor: this.getColorByState(),
				borderBottomWidth: 1,
				...this.props.underlineStyle,
			},
			underlineFocus: {
				borderColor: this.getColorByState(),
				borderBottomWidth: 1,
				...this.props.underlineFocusStyle,
			},
			icon: {
				opacity: 0.7,
				position: 'absolute',
				paddingLeft: '5px',
				paddingRight: '8px',
				right: '0px',
				top: '16px',
				height: '12px',
				width: '25px',
				cursor: 'pointer',
			},
			wrapper: {
				position: 'relative',
				...this.props.wrapperStyle,
			},
		};
	}

	render() {
		const style = this.getStyle();

		return (
			<div style={style.wrapper}>
				<TextField
					ref={ref => (this.domElement = ref)}
					autoComplete={false}
					data-valid={this.props.valid}
					defaultValue={this.props.defaultValue}
					errorStyle={style.errorStyle}
					errorText={this.props.valid ? undefined : this.props.errorHintText}
					fullWidth
					hintStyle={style.hintStyle}
					hintText={this.props.hintText}
					inputStyle={style.inputStyle}
					maxLength={this.props.maxlength}
					multiLine={this.props.multiline}
					name={this.props.name}
					onBlur={this.handleBlur(this.props.onBlur)}
					onChange={this.handleChange}
					onKeyUp={this.props.onKeyUp}
					onFocus={this.props.onFocus}
					placeholder={this.props.placeholder}
					rows={this.props.rows}
					rowsMax={this.props.rowsMax}
					style={style.textinput}
					textareaStyle={style.textareaStyle}
					type={this.props.type}
					underlineFocusStyle={style.underlineFocus}
					underlineDisabledStyle={style.underlineDisabled}
					underlineStyle={style.underline}
					value={this.state.value}
				/>
				{(!this.props.multiline && this.state.value) ? <CloseIcon
					color={Theme.palette.primary1Color}
					strokeColor={Theme.palette.primary1Color}
					style={style.icon}
					onTouchTap={this.clearInput}
				/> : null}
			</div>
		);
	}
}

export default Radium(TextInput);



// WEBPACK FOOTER //
// ./src/components/inputs/TextInput.js